export const productNames = {
  newron: 'gfknewron',
  predict_lite: 'gfknewron_lite',
  cie: 'consumer',
  pos_test: 'Digital MI',
  retail_insights: 'Retail Insights',
  eco_features: 'Eco Claim Reporting',
  retail_hitlists_standard: 'Retail Products',
  forecasting: 'Retail Forecasting',
  retail_market_premium: 'Retail Market Premium',
  seller_insights: 'Retail Marketplace Sellers',
  retail_key_account_data: 'Retail Key Account',
};

export const modulesToProducts = {
  cie: ['cie'],
  retail_insights: ['retail_insights'],
  retail_hitlists_standard: ['retail_hitlists_standard'],
  retail_market_premium: ['retail_market_premium'],
  retail_key_account_data: ['retail_key_account_data'],
  seller_insights: ['seller_insights'],
  basic_pos_market: ['newron', 'pos_test', 'predict_lite'],
  basic_pos_product: ['newron', 'pos_test', 'predict_lite'],
  tracking: ['newron', 'pos_test'],
  pos_distribution_market: ['newron', 'predict_lite'],
  pos_distribution_product: ['newron', 'pos_test', 'predict_lite'],
  tpr_insights: ['newron'],
  tpr_planning: ['newron'],
  price_elasticity: ['newron'],
  newron_insights: ['newron', 'predict_lite'],
  brand_insights_cie: ['newron', 'predict_lite'],
  brand_insights_pos: ['newron', 'predict_lite'],
  metadata: ['newron', 'pos_test', 'predict_lite'],
  recommendations: ['newron', 'pos_test', 'predict_lite'],
  forecasting: ['newron', 'predict_lite'],
  exec_view: ['newron', 'predict_lite'],
};
